import React, { SyntheticEvent } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { ENV_TWICPICS_URL_MEDIA } from 'settings/env';
import { COLORS as filtersColors } from 'settings/filters';

import styles from './ColorBubble.module.scss';

type PropsType = React.PropsWithChildren<{
  classes?: ClassesType;
  color: string;
  image: string;
  onClick?: (e: SyntheticEvent, color: string) => void;
  selected?: boolean;
  url: string;
}>;

export type ClassesType = {
  container?: string;
  image?: string;
  selected?: string;
};

export default function ColorBubble({
  children,
  classes,
  color,
  image,
  url,
  selected,
  onClick,
}: PropsType): JSX.Element {
  return (
    <Link
      to={url}
      className={classNames(styles.container, classes?.container, {
        [styles.selected]: selected,
      })}
      onClick={e => {
        if (selected) e.preventDefault();
        else onClick?.(e, color);
      }}
    >
      <div
        className={classNames(styles.image, classes?.image)}
        {...(image
          ? {
              'data-twic-background': `url(image:${ENV_TWICPICS_URL_MEDIA}${image})`,
              'data-twic-transform': 'cover=44x44',
            }
          : { style: { backgroundColor: filtersColors[color] } })}
      />
      {children}
    </Link>
  );
}
